import { equipmentAPI } from "api";

export const getAllUserManualAPI = (payload) => {
    return equipmentAPI.post("/api/manual/search",payload)
                .then((res) => res);
};
